const PRODUCTION_LINK =
  "https://d1ifx5r8od42fj.cloudfront.net/brands/configs/hit/config.json";
// const PRODUCTION_LINK =
//     "https://main.adsentory.com/api/v1/main-sites/configs/hit/config.json";
const PREVIEW_LINK =
    "https://main.adsentory.com/api/v1/main-sites/configs/hit/config.json";
let session = null;
let browser = null;

(() => {
    let $data_url;
    if (window.location.hostname.includes("preview")) {
        const params = new URLSearchParams(window.location.search);
        const version = params.get("version");
        const profile = params.get("profile");
        if (version && profile) {
            $data_url = `${PREVIEW_LINK}?&&version=${version}&&profile=${profile}`;
        } else {
            $data_url = `${PREVIEW_LINK}?v=${new Date().getTime()}`;
            console.log("Main Privew");
        }
    } else {
        $data_url = `${PRODUCTION_LINK}?v=${new Date().getTime()}`;
    }
    fetch($data_url)
        .then((response) => {
          if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
          }
          return response.json();  // ✅ Có thể đọc JSON
        })

        .then((data) => {
            const $data = data.config;
            const $app_ios = $data.iOS.appStore;
            const $app_ipa = $data.iOS.ipa;
            const $app_android = $data.android.chPlay;
            const $app_apk = $data.android.apk;
            // const listVersion = ["Version I", "Version II", "Version III"];
            // const version = $data.version;
            const logip = $data.ipTrackingLink;
            const webGame = $data.playInWebLink;
            const api = $data.registerLink;
            const $app_web = {
                isActive: webGame ? true : false,
                value: webGame,
            };

            // let isPlayWeb = $app_web.isActive ?? false;
            let isCHPlay =
                $app_android.enable && $data.android.isActive ? true : false;
            let isAppStore = $app_ios.enable && $data.iOS.isActive ? true : false;
            let isApk = $app_apk.enable && $data.android.isActive ? true : false;
            let isIpa = $app_ipa.enable && $data.iOS.isActive ? true : false;
            let allDied =
                (!$data.android.isActive && !$data.iOS.isActive) ||
                $data.allPlatformDied.isActive;

            // Detect user agent
            const userAgent = navigator.userAgent || navigator.vendor || window.opera;
            const isAndroid = /android/i.test(userAgent);
            const isIOS = /iPhone|iPad|iPod/i.test(userAgent);
            const isWindowsPhone = /windows phone/i.test(userAgent);
            // iPad Pro chạy Safari desktop mode có thể dùng "Macintosh" trong userAgent
            const isTouchDevice =
                "ontouchstart" in window || navigator.maxTouchPoints > 0;
            const isIPadPro = /Macintosh/.test(userAgent) && isTouchDevice;

            let isMobile = isAndroid || isIOS || isWindowsPhone || isIPadPro;
            let parser = new UAParser();
            parser.setUA(userAgent);
            let result = parser.getResult();
            browser = result.browser.name;
            // let aff_id = $('meta[name="aff_id"]').attr("content");
            // let sessionId = null;
            var aff_id = $('meta[name="aff_id"]').attr("content"),
                app_id = "bc114103",
                sessionId = null,
                // , isMobile = !0
                notifications = [],
                autofill = !1;


            function appCheck() {
                if (typeof window.$ == "undefined") {
                    window.$ = jQuery;
                }
                // switch version both wesbsite and mobile
                switch ($data.version) {
                    case 0:
                        $(".slogan").show();
                        $(".hddes_container").hide();
                        break;
                    case 1:
                        $(".version_1").show();
                        $(".slogan").show();
                        break;
                    case 2:
                        $(".version_2").show();
                        $(".slogan").hide();
                        break;
                    case 3:
                        $(".version_3").show();
                        $(".slogan").hide();
                        break;
                }

                if (isMobile) {
                    $('.version-pc').hide()
                    // Cả IOS và Android đều die
                    if (allDied) {
                        $("#iosDieApp-androidDieApp").show().removeClass("temp_class");
                        return;
                    }

                    $(".middleMessage").show();

                    //Ios còn App - Android còn App
                    if (isAppStore && isCHPlay) {
                        $("#iosOnApp-androidOnApp").show().removeClass("temp_class");
                        return;
                    }

                    //IOS còn APP - Android còn APK
                    if (isAppStore && isApk) {
                        $("#iosOnApp-androidAPK").show().removeClass("temp_class");
                        $("#huongdan").show();
                        if (isAndroid) $("#huongdan-apk").show();
                        return;
                    }

                    // IOS còn App - Android die toàn bộ App
                    if (isAppStore && !isCHPlay && !isApk) {
                        $("#iosOnApp-androidDieApp").show().removeClass("temp_class");
                        return;
                    }

                    //IOS còn IPA - Android còn App
                    if (isIpa && isCHPlay) {
                        $("#iosIPA-androidOnApp").show().removeClass("temp_class");
                        $("#huongdan").show();
                        $("#huongdan-ipa").show();
                        return;
                    }

                    //IOS còn IPA - Android còn APK
                    if (isIpa && isApk) {
                        $("#iosIPA-androidAPK").show().removeClass("temp_class");
                        // $(".bttomses").show();
                        $("#huongdan").show();
                        if (isAndroid) $("#huongdan-apk").show();
                        if (isIOS || isIPadPro) $("#huongdan-ipa").show();
                        return;
                    }

                    //IOS còn IPA - Android die toàn bộ App
                    if (isIpa && !isCHPlay && !isApk) {
                        $("#iosIPA-androidDieApp").show().removeClass("temp_class");
                        if (isIOS || isIPadPro) {
                            $("#huongdan").show();
                            $("#huongdan-ipa").show();
                        }
                        return;
                    }

                    //Ios die toàn bộ Apps - Android còn CHPlay
                    if (!isIpa && !isAppStore && isCHPlay) {
                        $("#iosDieApp-androidOnApp").show().removeClass("temp_class");
                        return;
                    }

                    //Ios die toàn bộ Apps - Android còn APK
                    if (!isIpa && !isAppStore && isApk) {
                        $("#iosDieApp-androidAPK").show().removeClass("temp_class");
                        if (isAndroid) {
                            $("#huongdan").show();
                            $("#huongdan-apk").show();
                        }
                        return;
                    }

                    // Cả IOS và Android đều die
                    if (!isIpa && !isAppStore && !isApk && !isCHPlay) {
                        $("#iosDieApp-androidDieApp").show().removeClass("temp_class");
                        return;
                    }
                }
                // if (isIPadPro) {
                //   $('.maindlapp').show()
                //   $('.ipadpro, #main').show()
                //   $('.btnplayweb').css({
                //     background: 'unset',
                //     padding: '0 0 10px',
                //     'margin-top': '0'
                //   })
                // }
            }

            $.validator.addMethod(
                "regex",
                function (e, t, n) {
                    var i = new RegExp(n);
                    return this.optional(t) || i.test(e);
                },
                ""
            );

            $(document).ready(function () {
                $("#pwd").on("input", function () {
                    let cleanValue = $(this)
                        .val()
                        .replace(/['";|\-]/g, "");
                    $(this).val(cleanValue);
                });
            });

            onRegFrmSubmit = function () {
                $("#registerForm").validate({
                    rules: {
                        username: {
                            required: !0,
                            regex: /^[A-Za-z0-9]*$/g,
                            minlength: 6,
                            maxlength: 15,
                        },
                        password: {
                            required: !0,
                            minlength: 6,
                            maxlength: 15,
                            regex: /^[A-Za-z0-9-~!@#$%^&*()\-_+={}\[\]|\\;:,<.>/?]{6,50}$/gim,
                        },
                        captcha: {
                            required: !0,
                            minlength: 6,
                            validCaptcha: true,
                        },
                    },
                    messages: {
                        username: {
                            required: "Vui lòng nhập tên đăng nhập",
                            minlength: "Tên đăng nhập không được ít hơn 6 ký tự",
                            maxlength: "Tên đăng nhập tối đa 15 ký tự",
                            regex: "Tên đăng nhập không được có dấu hoặc kí tự đặc biệt",
                        },
                        password: {
                            required: "Vui lòng nhập mật khẩu",
                            minlength: "Mật khẩu tối thiểu 6 ký tự",
                            maxlength: "Mật khẩu tối đa 15 ký tự",
                            regex:
                                "Mật khẩu không được có dấu, nháy đơn (') hoặc nháy kép (\")",
                        },
                        captcha: {
                            required: "Vui lòng nhập captcha",
                            minlength: "Captcha từ 6 ký tự trở lên",
                            validCaptcha: "Captcha không đúng",
                        },
                    },
                    errorElement: "div",
                    // errorPlacement: function (n, e) {
                    //     n.addClass("errors");
                    //     "captcha" == e.attr("name")
                    //         ? n.insertAfter(e.parent().parent())
                    //         : n.insertAfter(e);
                    // },
                    highlight: function (e, t, n) {
                    },
                    unhighlight: function (e, t, n) {
                    },
                    showErrors: function (e, t) {
                        // t = t.filter((err) => "validCaptcha" !== err["method"]);
                        this.defaultShowErrors();
                    },
                    submitHandler: function (e) {
                        return onRegister(), !1;
                    },
                    // invalidHandler: function (e, v) {
                    //     // show modal when click submit with invalid captcha only
                    //     if (
                    //         v.errorList.length === 1 &&
                    //         v.errorList[0].method === "validCaptcha"
                    //     ) {
                    //         $("#alertModal .modal-body").html("Captcha không hợp lệ");
                    //         $("#alertModal").modal();
                    //     }
                    // },
                });
            };

            appCheck();
            destroyAllTemp();

            onRegFrmSubmit();
            if (isMobile) {
                if (isAndroid) {
                    $(".showAndroid").show();
                } else {
                    $(".showIOS").show();
                }
            }

            onDownloadAndroid = function () {
                window.open(`${$app_android.link}?t=${new Date().getTime()}`, "_self");
                console.log("onDownloadAndroid:" + $app_android.link);
            };

            onDownloadApkAndroid = function () {
                (window.location.href = $app_apk.link),
                    setTimeout(function () {
                        jQuery("html, body").animate(
                            {
                                scrollTop: jQuery("#huongdan").offset().top,
                            },
                            500
                        );
                    }, 1e3);
                console.log("onDownloadAndroid:" + $app_apk.link);
            };

            onDownloadIos = function () {
                // window.open(`${$app_ios.link}?t=${new Date().getTime()}`, "_self");
                window.location.href = `${$app_ios.link}?t=${new Date().getTime()}`;
                console.log("onDownloadIos:" + $app_ios.link);
            };

            onDownloadIosKeygen = function () {
                const isKeygenApp =  $data.iOS.isKeygenApp;
                // const isKeygenApp = true

                if (isKeygenApp) {
                    $("html, body").addClass("body_overhidden");
                    $('.huongdan_swiper').addClass('show');
                    initSwiperGuide("#huongdan_subapp", "#swiper2", "#skipGuide2");
                    // initSwiperGuide("#huongdan_mainapp", "#swiper1", "skipGuide1");
                } else {
                    onDownloadIos()
                }
            };

            onDownloadIpa = function () {
                (window.location.href = $app_ipa.link),
                    setTimeout(function () {
                        jQuery("html, body").animate(
                            {
                                scrollTop: jQuery("#huongdan").offset().top,
                            },
                            500
                        );
                    }, 1e3);
                console.log("onDownloadIpa:" + $app_ipa.link);
            };

            onPlayWeb = function () {
                sessionId
                    ? window.open(
                        "https://" +
                        $app_web.value +
                        "?sessionid=" +
                        sessionId +
                        "&a=" +
                        aff_id +
                        location.search
                    )
                    : window.open(
                        "https://" + $app_web.value + "?a=" + aff_id + location.search
                    );
            };

            setCookiesLogIpv4 = function () {
                $.ajax({
                    url: "https://api4." + logip + "/sw/collect?aff_id=" + aff_id,
                    dataType: "json",
                    success: function (o, t) {
                    },
                    error: function (o, t, a) {
                    },
                });
            };

            setCookiesLogIpv6 = function () {
                $.ajax({
                    url: "https://api6." + logip + "/sw/collect?aff_id=" + aff_id,
                    dataType: "json",
                    success: function (o, t) {
                    },
                    error: function (o, t, a) {
                    },
                });
            };

            setCookiesLogIpv4();
            setCookiesLogIpv6();
            ("use strict");

            function receiveMessage(e) {
                void 0 !== e.data.session_id;
                // && onLoginFbSucceed(e.data.session_id);
            }

            window.addEventListener("message", receiveMessage, !1),
                $(document).ready(function () {
                    $("#registerForm").on("submit", function(e) {
                        e.preventDefault();
                        onRegister();
                    });
                    $(document).on("click", ".capcha_icon", function (e) {
                        e.preventDefault();
                        $(this).toggleClass("active");
                        // $(".recaptcha-bg").attr("src", "get-captcha.php?v=" + Date.now());
                    });
                    setCookiesTracking();
                    setTimeout(function () {
                        $(".pridiv-th").hide();
                    }, 2800);
                    $(".nano").nanoScroller();
                    setTimeout(function () {
                        Fingerprint2.get(function (e) {
                            var t = e.map(function (e) {
                                    return e.value;
                                }),
                                n = Fingerprint2.x64hash128(t.join(""), 31);
                            $("input[name='fg']").val(n);
                        });
                    }, 500);
                    $(document).on("click", ".icondown", function (e) {
                        e.preventDefault();
                        var t = $("#seoInfo").offset().top - 50;
                        $(this).addClass("active"),
                            $("body,html").animate(
                                {
                                    scrollTop: t,
                                },
                                400,
                                "swing"
                            );
                    });
                    $(window).scroll(function () {
                        $(window).scrollTop() > 50
                            ? $(".icondown").addClass("hidden")
                            : $(".icondown").removeClass("hidden");
                    });
                    var e = new UAParser();
                    e.setUA(userAgent);
                    var t = e.getResult();
                    $("input[name='browser']").val(t.browser.name),
                        $("input[name='os']").val(t.os.name),
                        $("input[name='device']").val(t.device.model);
                    var n = new URLSearchParams(window.location.search),
                        o = n.get("utm_source"),
                        a = n.get("utm_campaign"),
                        i = n.get("utm_content"),
                        s = n.get("utm_medium"),
                        r = n.get("utm_term");
                    return (
                        $("input[name='utm_source']").val(o),
                            $("input[name='utm_campaign']").val(a),
                            $("input[name='utm_content']").val(i),
                            $("input[name='utm_medium']").val(s),
                            $("input[name='utm_term']").val(r),
                            $("input").on("keypress", function (e) {
                                return " " !== e.key;
                            }),
                            $("input").on("input", function (e) {
                                const t = this.value;
                                t.includes(" ") && (this.value = t.replace(/\s/g, ""));
                            }),
                            $("input").bind("paste", function (e) {
                                e.preventDefault();
                                var t = e.originalEvent.clipboardData.getData("Text");
                                (t = t.replace(/\s+/g, "")), $(this).val(t);
                            }),
                            $(".nav-tabs a").on("click", function (e) {
                                setTimeout(function () {
                                    $(".nav-tabs > li").removeClass("active"),
                                        $(".nav-tabs > li:has(> a.active)").addClass("active");
                                }, 100);
                            }),
                            $(".form-group > .fa-eye").on("click", function (e) {
                                $(this).hasClass("fa-eye-slash")
                                    ? ($(this).removeClass("fa-eye-slash"),
                                        $(this).parent().children("input").attr("type", "password"))
                                    : ($(this).addClass("fa-eye-slash"),
                                        $(this).parent().children("input").attr("type", "text"));
                            }),
                            $('a[href^="#"]').click(function () {
                                var e = $(this).attr("href"),
                                    t = $("#" == e || "" == e ? "html" : e).offset().top - 50;
                                return (
                                    $("body,html").animate(
                                        {
                                            scrollTop: t,
                                        },
                                        400,
                                        "swing"
                                    ),
                                        !1
                                );
                            })
                    );
                });
            var onRegister = function () {
                    const e = new Go();
                    WebAssembly.instantiateStreaming(fetch("main.wasm"), e.importObject)
                        .then((t) => {
                            e.run(t.instance);
                        })
                        .then(() => {
                            var e = $("#usrname").val(),
                                t = $("#pwd").val(),
                                n = $("input[name='fg']").val(),
                                o = getSignedInUser(e, t, n),
                                a = $(".regFrm").serialize();
                            (a += "&d=" + encodeURIComponent(JSON.stringify(o))),
                                $.ajax({
                                    url: "https://hitclub-register.voni-154.workers.dev/",
                                    type: "POST",
                                    headers: {
                                        "X-CSRF-TOKEN": $('meta[name="csrf-token"]').attr(
                                            "content"
                                        ),
                                    },
                                    data: a,
                                    beforeSend: function (e) {
                                        $(".loading").show(),
                                        "undefined" != typeof dataLayer &&
                                        dataLayer.push({
                                            event: "formSubmitted",
                                            formName: "Click_Form_Register",
                                        });
                                    },
                                    dataType: "json",
                                    success: function (n, o) {
                                        if (
                                            ($(".loading").hide(),
                                                jQuery("html, body").animate(
                                                    {
                                                        scrollTop: 0,
                                                    },
                                                    100
                                                ),
                                            200 == n.code)
                                        ) {
                                            if (
                                                ("undefined" != typeof dataLayer &&
                                                (dataLayer.push({
                                                    event: "formSubmitted",
                                                    formName: "Form_Register",
                                                }),
                                                    dataLayer.push({
                                                        event: "formRegister",
                                                        formName: "Form_Register",
                                                    })),
                                                "undefined" != typeof _mgq &&
                                                _mgq.push(["MgSensorInvoke", "DangKy"]),
                                                "undefined" != typeof fbq &&
                                                fbq("track", "CompleteRegistration"),
                                                    (sessionId = n.data[0].session_id),
                                                (isCHPlay && /android/i.test(userAgent)) ||
                                                (isApk && isCHPlay && /android/i.test(userAgent)) ||
                                                ($data.iOS.ipa.enable &&
                                                    isAppStore &&
                                                    /iPad|iPhone|iPod/.test(userAgent) &&
                                                    !window.MSStream) ||
                                                (isApk && !isCHPlay && /android/i.test(userAgent)) ||
                                                ($data.iOS.ipa.enable &&
                                                    !isAppStore &&
                                                    /iPad|iPhone|iPod/.test(userAgent) &&
                                                    !window.MSStream) ||
                                                (isAppStore &&
                                                    /iPad|iPhone|iPod/.test(userAgent) &&
                                                    !window.MSStream) ||
                                                isIPadPro)
                                            ) {
                                                var a = t.substr(0, t.length - 3);
                                                return (
                                                    (t = t.replace(a, a.replace(/./g, "*"))),
                                                        $("#form").hide(),
                                                        $(".thankform").show(),
                                                        $(".thankinfo_user").html(
                                                            "<span>Tên đăng nhập:</span> " + e
                                                        ),
                                                        void $(".thankinfo_pass").html(
                                                            "<span>Mật khẩu:</span> " + t
                                                        )
                                                );
                                            }
                                            window.location.href =
                                                "https://" +
                                                $app_web.value +
                                                "?sessionid=" +
                                                n.data[0].session_id +
                                                "&a=" +
                                                aff_id;
                                        }
                                        200 != n.code &&
                                        ($("#alertModal .modal-body").html(n.message),
                                            $("#alertModal").modal());
                                    },
                                    error: function (e, t, n) {
                                        $(".loading").hide(),
                                            $("#alertModal .modal-body").html(
                                                "Lỗi xảy ra trong quá trình xử lý hệ thống. Xin vui lòng thử lại!"
                                            ),
                                            $("#alertModal").modal();
                                    },
                                });
                        });
                },
                showInfo = function (e) {
                    $(e).hide(), $("#info").removeClass("d-none");
                },
                setCookiesTracking = function () {
                    $.ajax({
                        url: api + "/sw/collect?aff_id=" + aff_id,
                        dataType: "json",
                        success: function (e, t) {
                        },
                        error: function (e, t, n) {
                        },
                    });
                };

            $(window).resize(function () {
                appCheck();
            });
        })
        .catch((error) => {
            console.error("Error fetching or parsing JSON:", error);
        });
})();

function destroyAllTemp() {
    $(".temp_class").remove();
}

function initSwiperGuide(appId,swiperId,skipBtn) {
    var r = 0
        , p = $(appId + " .swiper-slide").length - 1
        , l = new Swiper(swiperId, {
        mousewheel: !0,
        loop: !1,
        allowTouchMove: !0,
        spaceBetween: 0,
        pagination: {
            el: ".swiper-pagination",
            clickable: !0
        }
    });
    l.on("reachEnd", (function () {
            $(appId + " .swiper-button-next").addClass("swiper-button-disabled"),
            $(appId + " .swiper-button-next").css("pointer-events", "none")
        }
    )),
        $(skipBtn).click((function () {
            l.slideTo(0),
                $(appId).removeClass("show"),
                $("body").removeClass("body_overhidden"),
                $(appId + " .swiper-button-next").removeClass("swiper-button-disabled"),
                $(appId + " .swiper-button-next").removeAttr("style"),
                r = 0,
                location.reload()
            }
        )),

        $(appId + " .swiper_hdnext").on("touchstart", (function (e) {
                l.slideNext(),
                l.activeIndex == p && ($(this).addClass("swiper-button-disabled"))
            }
        )),

        $(appId + " .swiper-button-prev").on("touchstart", (function (e) {
                $(appId + " .swiper-button-next").removeClass("swiper-button-disabled"),
                $(appId + " .swiper-button-next").removeAttr("style"),
                l.slidePrev()
            }
        ))
}